import React, { useEffect, useState } from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { randomHexColorWithArray } from 'random-hex-color-generator';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

function SalesByCustomCollection() {
    const salesInsights = useSelector(
        (state) => state.reportAnalysis.salesInsights.salesInsights
    );

    const [sortedPieData, setSortedPieData] = useState([]);
    const [colors, setColors] = useState([]);
    const [total, setTotal] = useState(0);

    const location = useLocation();

    useEffect(() => {
        if (Object.keys(salesInsights).length > 0) {
            const pieChart = Object.entries(salesInsights.salesByCustomCollection).map(
                ([name, { val }]) => ({
                    name,
                    value: val === null ? 0 : val,
                })
            );

            const colorsArray = randomHexColorWithArray(pieChart.length);
            setColors(colorsArray);

            const totalValue = Object.values(salesInsights.salesByCustomCollection).reduce(
                (total, { val }) => total + (val === null ? 0 : val),
                0
            );

            setTotal(totalValue);
            setSortedPieData(pieChart);
        }
    }, [salesInsights]);

    return (
        <div className="border rounded-lg border-[#EAEAEA] col-span-1 w-full aspect-video p-5 flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <h1 className="font-semibold text-base">Sales by custom collection</h1>

                <Link
                    className="text-[#1055EB] font-semibold text-[12px] leading-6"
                    to={`${location.pathname}/sales-by-custom-collection`}
                >
                    View all data
                </Link>
            </div>

            {Object.keys(salesInsights).length > 0 ? (
                Object.keys(salesInsights.salesByCustomCollection).length > 0 ? (
                    <>
                        <ResponsiveContainer className="relative" width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={sortedPieData}
                                    innerRadius="60%"
                                    outerRadius="80%"
                                    paddingAngle={0}
                                    dataKey="value"
                                >
                                    {sortedPieData.map((_, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={colors[index % colors.length]}
                                        />
                                    ))}
                                </Pie>
                            </PieChart>

                            {/* ✅ Center text for top category */}
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[10px] text-black">
                                <div className="flex flex-col items-center gap-2">
                                    <div className="flex gap-2 items-center">
                                        <div
                                            className="rounded-[4px] size-3"
                                            style={{ backgroundColor: colors[0 % colors.length] }}
                                        ></div>

                                        <h2 className="text-[12px] leading-5 font-semibold text-[#666666]">
                                            {sortedPieData[0]?.name}
                                        </h2>
                                    </div>

                                    <h2 className="text-[16px] leading-5 font-semibold">
                                        {((sortedPieData[0]?.value / total) * 100).toFixed(0)}%
                                    </h2>
                                </div>
                            </div>
                        </ResponsiveContainer>

                        {/* ✅ Legend (excluding top item) */}
                        <div className="grid grid-cols-2 grid-rows-2 gap-x-16 max-[1152px]:gap-x-12 max-[1080px]:gap-x-6 gap-y-4">
                            {sortedPieData.slice(1).map((item, index) => {
                                const percentage = (item.value / total) * 100;
                                const color = colors[(index + 1) % colors.length];

                                return (
                                    <div
                                        className="flex w-full gap-2 items-center justify-between"
                                        key={index}
                                    >
                                        <div className="flex gap-2 items-center">
                                            <div
                                                className="rounded-[4px] size-3"
                                                style={{ backgroundColor: color }}
                                            ></div>

                                            <h2 className="text-[12px] leading-5 font-semibold text-[#666666]">
                                                {item.name}
                                            </h2>
                                        </div>

                                        <h2 className="text-[12px] leading-5 font-semibold">
                                            {percentage.toFixed(0)}%
                                        </h2>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                ) : (
                    <div className="m-auto">
                        <h1 className="font-normal italic text-base text-[#666666]">
                            No data available
                        </h1>
                    </div>
                )
            ) : (
                <div className="m-auto">
                    <h1 className="font-normal italic text-base text-[#666666]">
                        No data available
                    </h1>
                </div>
            )}
        </div>
    );
}

export default SalesByCustomCollection;
